import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPracticeLocationDetails } from "../../store/ProviderInfo/PracticeLocationAction";
import { Link } from "react-router-dom";
import "./practicelocation.scss";
import locationMarkIcon from "../../assets/images/ic-practice-off.svg";
import locationMarkIconHover from "../../assets/images/ic-practice-on.svg";

const PracticeLocation = ({ providerId }) => {
  const [showError, setShowError] = useState(false);
  const dispatch = useDispatch();
  const { practiceLocationData, practiceLocationError } = useSelector(
    (state) => state.practiceLocationDetails
  );

  useEffect(() => {
    dispatch(fetchPracticeLocationDetails(providerId));
  }, []);

  useEffect(() => {
    if (practiceLocationError) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [practiceLocationError]);

  const RenderPracticeLocError = () => {
    if (!showError) return null;
    return (
      <div className="overlay-alert alert alert-danger" role="alert">
        {practiceLocationError}
      </div>
    );
  };

  return (
    <div>
      <div id="provider-sidebar" className="sidebar">
        <div className="sidebar-section">
          <div className="sidebar-header">
            <h2 className="sidebar-header-text">
              <span>Practicing Locations</span>
            </h2>
          </div>
        </div>
        <ul className="sidebar-nav-list">
          {RenderPracticeLocError()}
          {practiceLocationData?.filter(locationData => locationData.state === "ACTIVE")?.map((item) => {
            return (
              <li key={item.practiceId}>
                <Link
                  className="practice-location-clickable"
                  to={`/practice/${item.displayId}/profile-information/info`}
                >
                  <img
                    className="practice-location-mark"
                    src={locationMarkIcon}
                    width={30}
                    height={30}
                  />
                  <img
                    className="practice-location-mark-hover"
                    src={locationMarkIconHover}
                    width={30}
                    height={30}
                  />
                  <span className="practice-item">{item.name}</span>
                </Link>
                <address className="provider-address">
                  <span>
                    {item.streetAddress.street1}, {item.streetAddress.street2}
                  </span>
                  <br />
                  <span>
                    {item.streetAddress.city}, {item.streetAddress.state}{" "}
                    {item.streetAddress.postalCode}
                  </span>
                </address>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default PracticeLocation;
